import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Flex, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch, useSelector } from 'react-redux';
import { clearClickThroughView } from 'reducers/okrsPageSlice';
import Heading from 'screens/Team/Rabbit/Goals/Header/Heading';
import { okrsInsightsSelector } from 'selectors/okrsInsightsSelector';

import { ArrowRight } from 'assets/assetsV1/iconComponents';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { TextLabelSmall } from 'uiToolkitV1/Typography';

const StyledBreadcrumb = styled(Breadcrumb)`
  ol {
    margin: 0px;
    padding-left: 0px;
  }
`;
export const BreadCrumbHeader = ({ updateDateRange }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const { clickThroughViewData } = useSelector(okrsInsightsSelector);

  /*  read keyResultsName and objectivesName from new config */
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  const goToInsightsView = () => {
    dispatch(clearClickThroughView());
  };

  const VISIBLE_BREADCRUMBS = [
    {
      label: modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE),
      onClick: () => () => {},
      isCurrentPage: false,
    },
    {
      label: 'Insights',
      onClick: () => {
        goToInsightsView();
      },
      isCurrentPage: false,
    },
    {
      label: clickThroughViewData?.name,
      onClick: () => {},
      isCurrentPage: true,
    },
  ];

  return (
    <Flex
      justify="space-between"
      alignItems="flex-start"
      px={6}
      pt={3}
      pr={4}
      pb={2}
      bgColor={theme.colors.surface.F5F7F9}
    >
      <Box flexGrow={1}>
        <StyledBreadcrumb px={3} pt={1.5} spacing={0} separator={<ArrowRight color={theme.colors.text.g2} />}>
          {VISIBLE_BREADCRUMBS.map(({ label, onClick, isCurrentPage }, index) => {
            const lastItem = index + 1 === VISIBLE_BREADCRUMBS.length;
            return (
              <BreadcrumbItem key={index}>
                {index === 0 ? (
                  <BreadcrumbLink style={{ textDecoration: 'none' }} onClick={onClick}>
                    <TextLabelSmall bold={!!lastItem}>{label}</TextLabelSmall>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbLink onClick={onClick}>
                    <TextLabelSmall bold={!!lastItem}>{label}</TextLabelSmall>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            );
          })}
        </StyledBreadcrumb>

        <Heading
          teamName={`${clickThroughViewData?.name}'s ${modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)}`}
          containerProps={{ mb: '8px' }}
          textProps={{ py: '0px' }}
        />
      </Box>
    </Flex>
  );
};
